import React, {useContext, useState} from "react";
import {loginUser} from "../../Api/Api";
import AuthContext from "../Common/AuthContext";
import {useNavigate} from "react-router-dom";

const LoginPage = () => {
    const [formData, setFormData] = useState({
        emailId: "",
        password: "",
    });
    const [error, setError] = useState("");
    const authCtx = useContext(AuthContext);
    const navigate = useNavigate();

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError("");

        try {
            const response = await loginUser(formData);
            console.log("Login successful:", response.data);
            // Save the token to localStorage or context
            if(response.status ===  200 ){
                authCtx.login(response.data)
                navigate("/workshops/dashboard/"+response.data.workshopId);
            }
            // localStorage.setItem("token", response.data.token);
            // Redirect to dashboard or home page

        } catch (err) {
            setError("Invalid username or password");
            console.error("Login error:", err);
        }
    };

    return (
        <div className="min-h-screen flex items-center justify-center ">
            <div className="bg-white p-10 rounded-xl shadow-lg w-full max-w-md">
                {/* Logo */}
                <div className="flex justify-center mb-6">
                    <img src="/img/xillion-logo.webp" width="100px" alt="XillionTech Logo" className="h-14" />
                </div>

                <h2 className="text-3xl font-bold mb-6 text-center text-gray-800">Welcome Back</h2>

                {error && <p className="text-red-500 text-sm text-center mb-4">{error}</p>}

                <form onSubmit={handleSubmit}>
                    <div className="mb-4">
                        <label className="block text-sm font-medium text-gray-700">Username</label>
                        <input
                            type="text"
                            name="emailId"
                            value={formData.emailId}
                            onChange={handleChange}
                            className="mt-1 block w-full px-4 py-2 border border-gray-300 rounded-lg shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 text-gray-700"
                            required
                        />
                    </div>
                    <div className="mb-6">
                        <label className="block text-sm font-medium text-gray-700">Password</label>
                        <input
                            type="password"
                            name="password"
                            value={formData.password}
                            onChange={handleChange}
                            className="mt-1 block w-full px-4 py-2 border border-gray-300 rounded-lg shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 text-gray-700"
                            required
                        />
                    </div>
                    <button
                        type="submit"
                        className="w-full bg-indigo-600 text-white py-3 rounded-lg hover:bg-indigo-700 transition duration-300 focus:outline-none focus:ring-2 focus:ring-indigo-500"
                    >
                        Login
                    </button>
                </form>

                <p className="text-sm text-center text-gray-600 mt-4">
                    {/*Don't have an account? <a href="/register" className="text-indigo-600 hover:underline">Sign up</a>*/}
                </p>
            </div>
        </div>
    );
};

export default LoginPage;